export default "<app-header></app-header>\r\n\r\n<div class=\"content m-t-47\" fxLayout=\"column\">\r\n    <router-outlet></router-outlet>\r\n</div>"